type ValidateSingleSelectionBoxOnCustomFormParams = {
  option: string
  isRequired?: boolean
}

export default function validateSingleSelectionBoxOnCustomForm({
  option,
  isRequired,
}: ValidateSingleSelectionBoxOnCustomFormParams) {
  let error = ''
  if (isRequired && !option) {
    error = 'Este campo é obrigatório'
  }

  return error
}
